import React from 'react'


//画面遷移後にページトップに戻したい画面に利用するコンポーネント
export default class ScrollToTopOnMount extends React.Component {
  componentDidMount(prevProps) {
    window.scrollTo(0, 0)
  }

  render() {
    return null
  }
}
